import { Component } from "@angular/core";

@Component({
  selector: "jni-inventory-purchase",
  templateUrl: "./inventory-purchase.component.html",
  styleUrls: ["./inventory-purchase.component.scss"],
})
export class InventoryPurchaseComponent {}
